import { useState } from "react";
import {
  Row,
  Col,
  Typography,
  Button,
  Divider,
  Space,
  Popconfirm,
  message,
  notification,
  Skeleton,
} from "antd";
import { Colors } from "theme";
import { Carousel } from "react-responsive-carousel";
import API_KEY from "api";
import { useHistory } from "react-router-dom";
import { Shimmer } from "components/Shimmer";
import { gaEvent } from "analytics/analytics";
import * as GA from "../../../constants/analytics";
import VariantsTable from "components/ProductDetailsModal/VariantsTable";
import {
  InfoContainer,
  PriceTitle,
  FileList,
} from "components/ProductDetailsModal/ModalHelpers";
import Can from "../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
const { Title, Text } = Typography;
export default function ProductModal({ data, modalData }) {
  const [deletePopConfirm, setdeletePopConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);
  const [simmerDisplay, setSimmerDisplay] = useState("none");
  const history = useHistory();
  const openNotificationWithIcon = (type = "error") => {
    notification[type]({
      message: "This product is part of catalogues!",
      description:
        "Unable to delete this product at the moment as it is part of catalogues sent to buyers.",
    });
  };

  const deleteProduct = (deleteId) => {
    setLoading(true);
    API_KEY.URL.delete(`${API_KEY.path.products}/${deleteId}`)
      .then((res) => {
        setTimeout(function () {
          message.success("Product deleted!");
          setLoading(false);
          sessionStorage.clear();
          history.push(
            `/categorywise-products/${data.secondary_category.name}/${data.secondary_category.id}`
          );
          window.location.reload();
        }, 3000);
        setdeletePopConfirm((state) => !state);
      })
      .catch((error) => {
        openNotificationWithIcon();
        setdeletePopConfirm((state) => !state);
      });
  };
  const onCancelDelete = () => {
    setdeletePopConfirm((state) => !state);
  };
  const handleDeleteButtonclick = () => {
    setdeletePopConfirm((state) => !state);
  };
  const onloadImg = () => {
    setImgLoaded("true");
    setSimmerDisplay("");
  };

  return (
    <>
      {data ? (
        <Row className="product-details-modal" align="middle">
          <Col>
            <Row>
              <Col span={12}>
                <Carousel showThumbs={true} thumbWidth={100}>
                  {data?.product_images?.map((item, index) => (
                    <div>
                      <img
                        src={`${process.env.REACT_APP_CLOUDINARY}/b_rgb:f2f2f2,c_pad,h_1200,q_100,w_1800/${item.directus_files_id.id}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `${process.env.REACT_APP_DIRECTUS}assets/${item.directus_files_id.id}?transforms=[["resize",{"width":1800,"height":1200,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`;
                        }}
                        alt={"something"}
                        key={index}
                        onLoad={onloadImg}
                        style={{ display: `${simmerDisplay}` }}
                        onFocus={() => {
                          gaEvent(
                            GA.EVENT.HOVER,
                            GA.CATEGORY.ADD_PRODUCT,
                            GA.DESCRIPTION.PRODUCT_DETAILS_IMAGE_CAROUSEL_IMAGE,
                            data?.product_id
                          );
                        }}
                      />

                      {!imgLoaded ? (
                        <Shimmer style={{ height: "20em", width: "42em" }} />
                      ) : null}
                    </div>
                  ))}
                </Carousel>
              </Col>
              <Col span={10} offset={2} className="product-info">
                <Row>
                  <Title
                    className="product-id"
                    // type="secondary"
                    style={{ fontFamily: "Avenir", marginBottom: "0.5rem" }}
                    level={5}
                  >
                    {data?.product_id ? "ID: " + data?.product_id : ""}
                  </Title>
                </Row>


                <Row align="bottom">
                  <Can
                    I={PERMISSIONS.global_permissions.slug}
                    a={PERMISSIONS.global_permissions.permissionType}
                  >
                    <PriceTitle data={modalData.priceTitle} />
                    <Divider style={{ margin: "0.5rem", border: "0px" }} />
                  </Can>
                </Row>

                {data?.sub_category && (
                  <Row>
                    <Col span={8}>
                      <Title
                        style={{ fontSize: "16px", margin: 0 }}
                        type="secondary"
                      >
                        {`Sub Category`}
                      </Title>
                    </Col>

                    <Col span={15} offset={1}>
                      <span
                        style={{
                          fontSize: "16px",
                          paddingTop: "4px",
                          //  overflowWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                         {data?.sub_category.split(',').join(', ')}
                      </span>
                    </Col>
                  </Row>
                )}
                <InfoContainer data={modalData?.productionDetails} />

                <Can
                  I={
                    PERMISSIONS.update_products.slug ||
                    PERMISSIONS.delete_products.slug
                  }
                  a={PERMISSIONS.update_products.permissionType}
                >
                  <Divider style={{ margin: "0.5rem", border: "0px" }} />
                </Can>

                <Row justify="space-between">
                  <Can
                    I={PERMISSIONS.delete_products.slug}
                    a={PERMISSIONS.delete_products.permissionType}
                  >
                    <Col xl={10} xx={10} lg={10} md={24} sm={24} xs={24}>
                      <Popconfirm
                        title="Are you sure you want to delete this product?"
                        visible={deletePopConfirm}
                        onConfirm={() => deleteProduct(data?.id)}
                        onCancel={onCancelDelete}
                      >
                        <Button
                          size="large"
                          loading={loading}
                          style={{
                            width: "100%",
                            background: Colors.white,
                            color: Colors.danger,
                            borderColor: Colors.danger,
                            marginTop: "0.3em",
                          }}
                          onClick={() => {
                            handleDeleteButtonclick();
                            gaEvent(
                              GA.EVENT.CLICK,
                              GA.CATEGORY.ADD_PRODUCT,
                              GA.DESCRIPTION.PRODUCT_DETAILS_DELETE_BUTTON,
                              data?.product_id
                            );
                          }}
                        >
                          {loading ? "Deleting..." : "Delete"}
                        </Button>
                      </Popconfirm>
                    </Col>
                  </Can>
                  <Can
                    I={PERMISSIONS.update_products.slug}
                    a={PERMISSIONS.update_products.permissionType}
                  >
                    <Col xl={10} xx={10} lg={10} md={24} sm={24} xs={24}>
                      <Button
                        size="large"
                        style={{
                          background: "#363E3D",
                          color: "white",
                          width: "100%",
                          border: 0,
                          marginTop: "0.3em",
                          fontSize: "",
                        }}
                        onClick={() => {
                          history.push(`/edit-product/${data?.id}`);
                          gaEvent(
                            GA.EVENT.CLICK,
                            GA.CATEGORY.ADD_PRODUCT,
                            GA.DESCRIPTION.PRODUCT_DETAILS_EDIT_BUTTON,
                            data?.product_id
                          );
                        }}
                      >
                        Edit details
                      </Button>
                    </Col>
                  </Can>
                </Row>

                <Can
                  I={
                    PERMISSIONS.update_products.slug ||
                    PERMISSIONS.delete_products.slug
                  }
                  a={PERMISSIONS.update_products.permissionType}
                >
                  <Divider style={{ margin: "0.5rem", border: "0px" }} />
                </Can>

                {!!data?.variants?.length &&
                  data?.variants?.[0]?.attributes?.length > 0 && (
                    <VariantsTable data={data.variants} />
                  )}
                {!!data?.variants?.length &&
                  data?.variants?.[0]?.attributes?.length > 0 && (
                    <Divider style={{ margin: "0.5rem", border: "0px" }} />
                  )}

                <InfoContainer data={modalData.others} />
                <Divider style={{ margin: "0.5rem", border: "0px" }} />
                <FileList data={modalData?.others} />
              </Col>
            </Row>
          </Col>
        </Row>
      ) : (
        <Skeleton active />
      )}
    </>
  );
}
